import { render } from "./CurrencyFilter.vue?vue&type=template&id=61f376a1"
import script from "./CurrencyFilter.vue?vue&type=script&lang=js"
export * from "./CurrencyFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__